import React from 'react'

const PrepaidRevenueIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <g paintOrder="fill markers stroke">
                        <path
                            fill="#4aa7ff"
                            d="M20.5 18a2.506 2.506 0 0 0-2.5 2.5v23c0 1.376 1.124 2.5 2.5 2.5h37c1.376 0 2.5-1.124 2.5-2.5v-23c0-1.376-1.124-2.5-2.5-2.5z"
                            opacity={1}
                            data-original="#4aa7ff"
                            className=""
                        />
                        <path
                            fill="#064781"
                            d="M18 22v6h42v-6z"
                            opacity={1}
                            data-original="#064781"
                            className=""
                        />
                        <path
                            fill="#d7e7f5"
                            d="M49 36c-1.653 0-3 1.347-3 3s1.347 3 3 3h4c1.653 0 3-1.347 3-3s-1.347-3-3-3z"
                            opacity={1}
                            data-original="#d7e7f5"
                        />
                        <path
                            fill="#a6d4ff"
                            d="M6.5 11A2.506 2.506 0 0 0 4 13.5v37C4 51.876 5.124 53 6.5 53h23c1.376 0 2.5-1.124 2.5-2.5v-37c0-1.376-1.124-2.5-2.5-2.5z"
                            opacity={1}
                            data-original="#a6d4ff"
                        />
                        <path
                            fill="#d7e7f5"
                            d="m32 19-11 5.08v11.89c0 1.05.737 2.08 1.764 3.086 1.028 1.006 2.377 1.988 3.724 2.857a55.007 55.007 0 0 0 5.382 3.024L32 45l.13-.063s2.688-1.285 5.382-3.024c1.347-.87 2.696-1.85 3.724-2.857C42.263 38.05 43 37.02 43 35.971V24.08zM11.5 42C9.573 42 8 43.573 8 45.5S9.573 49 11.5 49s3.5-1.573 3.5-3.5-1.573-3.5-3.5-3.5z"
                            opacity={1}
                            data-original="#d7e7f5"
                        />
                        <path
                            fill="#064781"
                            d="m32 22.596-8 3.678v8.569c0 .795.55 1.544 1.296 2.271.746.728 1.72 1.433 2.692 2.057a39.735 39.735 0 0 0 3.88 2.17l.132.063.132-.063s1.937-.922 3.88-2.17c.972-.624 1.946-1.33 2.692-2.057.747-.727 1.296-1.476 1.296-2.271v-8.57z"
                            opacity={1}
                            data-original="#064781"
                            className=""
                        />
                        <path
                            fill="#4aa7ff"
                            d="M11.5 38C9.573 38 8 39.573 8 41.5S9.573 45 11.5 45s3.5-1.573 3.5-3.5-1.573-3.5-3.5-3.5z"
                            opacity={1}
                            data-original="#4aa7ff"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default PrepaidRevenueIcon